export default { sha: '9f20a523f8a85fb5410ed2e7ef05cebbf5f7276a', buildNumber: 'undefined' }
